


























































import LocationsService from '@/services/LocationsService'
import {
  computed,
  defineComponent,
  onMounted,
  ref,
} from '@vue/composition-api'
import Multiselect from 'vue-multiselect'
import { ObserveVisibility } from 'vue-observe-visibility'
import Vue from 'vue'
Vue.directive('observe-visibility', ObserveVisibility)
import 'vue-multiselect/dist/vue-multiselect.min.css'
import debounce from 'lodash/debounce'

export default defineComponent({
  components: { Multiselect },

  props: {
    value: {
      type: [Array, String, Object],
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    removeCurrentLocation: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: Number,
      default: 300,
    },
    placeholder: {
      type: String,
      default: 'Search for locations',
    },
    maxSelectableLocations: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const pagniationSize = 30

    const selectedLocations = computed({
      get(){
        let selectedValues = props.multiple ? [] : {}
        if(props.value){
          selectedValues = props.value as any
        }
        return selectedValues
      },
      set(value){
        ctx.emit('input', value)
      }
    })

    const locations = ref<Array<any>>([])
    const limit = ref(pagniationSize)
    const skip = ref(0)
    const searchText = ref('')
    const isLoading = ref(false)
    const totalLocations = ref(0)
    const route = ctx.root.$route
    const enableHasNextOption = ref(false)

    const hasNextPage = computed(() => {
      return locations.value.length < totalLocations.value
    })

    async function loadLocationData() {
      try {
        isLoading.value = true
        const auth = await ctx.root.$store.dispatch('auth/get')

        let { locations: locationRawData, hit } = await LocationsService.search(
          auth.companyId,
          false,
          undefined,
          skip.value,
          limit.value,
          searchText.value
        )

        totalLocations.value = hit.length ? hit[0].count : 0
        if (!locationRawData) return

        locationRawData = await locationRawData
          .map((location: any) => {
            const { _id: id, name, ...result } = location

            if (props.removeCurrentLocation) {
              if (route.params.location_id === id) {
                return null
              }
            }

            return {
              ...result,
              name: name || 'NO NAME',
              id,
            }
          })
          .filter((location: any) => location)

        if (searchText.value) {
          locations.value = locationRawData
        } else {
          locations.value.push(...locationRawData)
        }
        enableHasNextOption.value = true
        isLoading.value = false
      } catch (error) {
        isLoading.value = false
        console.error(error)
      }
    }

    const onAsyncSearch = debounce((query: string) => {
      limit.value = pagniationSize
      skip.value = 0
      searchText.value = query
      if (!query) {
        locations.value = []
        enableHasNextOption.value = false
        loadLocationData()
        return
      }
      loadLocationData()
    }, 500)

    function reachedEndOfList(reached: any) {
      if (reached && enableHasNextOption.value) {
        skip.value += limit.value
        loadLocationData()
      }
    }
    function limitText(count: number) {
      return `and ${count} other locations`
    }

    function clearPagination() {
      skip.value = 0
      limit.value = pagniationSize
      searchText.value = ''
    }

    function clearAll() {
      selectedLocations.value = []
      clearPagination()
    }


    onMounted(() => {
      loadLocationData()
    })

    return {
      locations,
      hasNextPage,
      selectedLocations,
      isLoading,
      onAsyncSearch,
      limitText,
      totalLocations,
      reachedEndOfList,
      clearAll,
      enableHasNextOption,
    }
  },
})
